<script setup lang="ts">
const props = defineProps({
  item: Object,
})
</script>

<template>
  <div class=" bg-white rounded-xl p-5 h-[138px]  flex flex-col justify-between transition-shadow hover:shadow-md">

    <h3 class="text-sm text-center text-[#1b325a] font-medium  mb-2">{{ item?.label }}</h3>

    <div class="flex items-end justify-between gap-5">

      <a :href="item?.linkUrl" :target="item?.newTab ? '_blank' : undefined"
        :rel="item?.newTab ? 'noopener noreferrer' : undefined"
        class="text-[10px] text-[#25a658] hover:underline mt-4 font-medium inline-flex items-center gap-1.5">
        مشاهده‌ی پرونده‌ها
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 rotate-180" fill="none" viewBox="0 0 22 22"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M9 5l7 7-7 7" />
        </svg>
      </a>
      <p
        class=" px-2 h-[52px] text-[22px] font-fa font-medium min-w-[52px] flex items-center justify-center  text-[#1b325a] bg-[#eaeef5] rounded-md ">
        {{ item?.count.toLocaleString() }}
      </p>
    </div>

  </div>
</template>
